module.exports = "<template> <span ref=popover class=popover-icon class.bind=iconClass> <slot></slot> </span> </template> ";